import {NgbDateStruct} from '@ng-bootstrap/ng-bootstrap';

export class SearchDocument {
  partnerId: number;
  enterpriseId: number;
  workflowId: number;
  documentNumber: string;
  fullName: string;
  ruc: string;
  businessName: string;
  subject: string;
  uploader: string;
  states: string;
  dateFrom: string;
  dateTo: string;
  // tslint:disable-next-line:variable-name
  dateFrom_: NgbDateStruct;
  // tslint:disable-next-line:variable-name
  dateTo_: NgbDateStruct;
  active: number;
}
